import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation, Translator } from '@morningtrain/react-translations'

export default function DiscountsTables () {
  return (
    <ValueToCollection name='table'>
      <ForEachModel>
        <UI.Card tight className='pt-6 sm:pt-10'>
          <UI.CardHeader withPadding>
            <UI.SecondaryHeading>
              <Displays.Text name='key' />
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <ValueToCollection name='collection'>
            <Table
              striped
              footer={(
                <tr>
                  <Columns.Column>
                    <Translation name='generic.total' />
                  </Columns.Column>
                  <Columns.Column alignment='right'>
                    <UI.PipedValues
                      secondary={(
                        <Displays.AggregateRatio
                          name='employee_percentage' outOfName='total_revenue'
                          display={(
                            <Displays.Percentage
                              decimals={2}
                            />
                          )}
                        />
                      )}
                    >
                      <Displays.Aggregate name='employee_usage' display={<Displays.Currency />} />
                    </UI.PipedValues>
                  </Columns.Column>
                  <Columns.Column alignment='right'>
                    <UI.PipedValues secondary={(
                      <Displays.AggregateRatio
                        name='onthehouse_usage_percentage'
                        outOfName='total_revenue'
                        display={(
                          <Displays.Percentage
                            decimals={2}
                          />
                      )}
                      />
                      )}
                    >
                      <Displays.Aggregate name='onthehouse_usage' display={<Displays.Currency />} />
                    </UI.PipedValues>
                  </Columns.Column>
                  <Columns.Column alignment='right'>
                    <UI.PipedValues
                      secondary={(
                        <Displays.AggregateRatio
                          name='discount_percentage'
                          outOfName='total_revenue'
                          display={<Displays.Percentage decimals={2} />}
                        />
                             )}
                    >
                      <Displays.Aggregate name='discount_usage' display={<Displays.Currency />} />
                    </UI.PipedValues>
                  </Columns.Column>
                  <Columns.Column alignment='right'>
                    <UI.PipedValues
                      secondary={<Displays.AggregateRatio
                        name='giftcard_percentage' outOfName='total_revenue'
                        display={<Displays.Percentage decimals={2} />}
                                 />}
                    >
                      <Displays.Aggregate name='giftcard_usage' display={<Displays.Currency />} />
                    </UI.PipedValues>
                  </Columns.Column>
                  <Columns.Aggregate
                    alignment='right'
                    name='total_revenue'
                    display={<Displays.Currency />}
                  />
                </tr>
                     )}
            >
              <Columns.Column
                name='month'
                label={<Translation name='generic.month' />}
              >
                <UI.Text weight='medium'>
                  <Displays.Date name='date' dateFormat='MMMM YYYY' />
                </UI.Text>
              </Columns.Column>
              <Columns.Column
                name='employee_food'
                alignment='right'
                label={<Translation name='columns.employee_food' />}
              >
                <UI.PipedValues
                  secondary={<Displays.Percentage name='employee_percentage' decimals={2} defaultValue={0} />}
                >
                  <Displays.Currency name='employee_usage' defaultValue={0} />
                </UI.PipedValues>
              </Columns.Column>
              <Columns.Column
                name='onthehouse_food'
                alignment='right'
                label={<Translation name='columns.onthehouse_food' />}
              >
                <UI.PipedValues
                  secondary={<Displays.Percentage name='onthehouse_percentage' decimals={2} defaultValue={0} />}
                >
                  <Displays.Currency name='onthehouse_usage' defaultValue={0} />
                </UI.PipedValues>
              </Columns.Column>
              <Columns.Column
                name='discount_food'
                alignment='right'
                label={<Translation name='columns.discount_food' />}
              >
                <UI.PipedValues
                  secondary={<Displays.Percentage name='discount_percentage' decimals={2} defaultValue={0} />}
                >
                  <Displays.Currency name='discount_usage' defaultValue={0} />
                </UI.PipedValues>
              </Columns.Column>
              <Columns.Column
                name='giftcard_food'
                alignment='right'
                label={<Translation name='columns.giftcard_food' />}
              >
                <UI.PipedValues
                  secondary={<Displays.Percentage name='giftcard_percentage' decimals={2} defaultValue={0} />}
                >
                  <Displays.Currency name='giftcard_usage' defaultValue={0} />
                </UI.PipedValues>
              </Columns.Column>
              <Columns.Currency
                alignment='right'
                name='total_revenue'
                label={<Translation name='generic.total' />}
              />
            </Table>
          </ValueToCollection>
        </UI.Card>
      </ForEachModel>
    </ValueToCollection>
  )
}
